import React, { useState } from "react";
import { TriggerNode } from "../../../../views/convoauto-pages/bot-studio/types";
import { NodeMenu } from "../../../shared/trigger-shared/node-menu";
import { RightDot } from "../../../shared/action-core";
import { DeleteModal } from "../../../shared/trigger-shared/delete-modal";

interface LeadFromCTWATriggerCardProps {
  node: TriggerNode;
  onChange: (n: TriggerNode) => void;
  onDelete: () => void;
  onReset: () => void;
}

export const LeadFromCTWATriggerCard: React.FC<LeadFromCTWATriggerCardProps> = ({
  node,
  onChange,
  onDelete,
  onReset,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const updateField = (field: keyof TriggerNode, value: unknown) =>
    onChange({ ...node, [field]: value });

  return (
    <>
      <div className="relative">
        <div className="absolute -top-7 left-0">
          <span className="bg-gray-800 text-white text-xs px-3 py-1 rounded-full">
            Bot Starting Point
          </span>
        </div>
        <div className="bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm p-4 min-w-[260px]">
          <div className="flex items-center justify-between mb-3">
            <p className="text-indigo-600 font-semibold text-sm">{node.type}</p>
            <NodeMenu onDelete={() => setShowDeleteModal(true)} onReset={onReset} />
          </div>

          <label className="block text-xs text-gray-500 dark:text-gray-400 mb-1">Select WABA</label>
          <div className="relative mb-3">
            <select
              value={node.waba as string}
              onChange={(e) => updateField("waba", e.target.value)}
              className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm appearance-none bg-white dark:bg-gray-900 pr-8 focus:outline-none focus:ring-1 focus:ring-indigo-300"
            >
              <option>All WABA</option>
              <option>WABA 1</option>
              <option>WABA 2</option>
            </select>
            <div className="absolute right-2 top-3 pointer-events-none">
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-none stroke-gray-500 stroke-2"><polyline points="6 9 12 15 18 9" /></svg>
            </div>
          </div>

          <label className="block text-xs text-gray-500 dark:text-gray-400 mb-1">Track leads from</label>
          <div className="relative mb-3">
            <select
              value={node.trackLeadsFrom as string}
              onChange={(e) => updateField("trackLeadsFrom", e.target.value)}
              className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm appearance-none bg-white dark:bg-gray-900 pr-8 focus:outline-none focus:ring-1 focus:ring-indigo-300"
            >
              <option>All Broadcasts</option>
              <option>Specific Broadcast</option>
              <option>Audience Segment</option>
            </select>
            <div className="absolute right-2 top-3 pointer-events-none">
              <svg viewBox="0 0 24 24" className="w-4 h-4 fill-none stroke-gray-500 stroke-2"><polyline points="6 9 12 15 18 9" /></svg>
            </div>
          </div>

          {node.trackLeadsFrom === "Specific Broadcast" && (
            <>
              <label className="block text-xs text-gray-500 dark:text-gray-400 mb-1">Select Broadcast</label>
              <div className="relative">
                <select
                  value={(node.broadcast as string) || "Summer Sale 20%"}
                  onChange={(e) => updateField("broadcast", e.target.value)}
                  className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm appearance-none bg-white dark:bg-gray-900 pr-8 focus:outline-none focus:ring-1 focus:ring-indigo-300"
                >
                  <option>Summer Sale 20%</option>
                  <option>Winter Promo</option>
                  <option>Flash Sale</option>
                </select>
                <div className="absolute right-2 top-3 pointer-events-none">
                  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-none stroke-gray-500 stroke-2"><polyline points="6 9 12 15 18 9" /></svg>
                </div>
              </div>
            </>
          )}

          {node.trackLeadsFrom === "Audience Segment" && (
            <>
              <label className="block text-xs text-gray-500 dark:text-gray-400 mb-1">Select Segment</label>
              <div className="relative">
                <select
                  value={(node.segment as string) || "New Customers"}
                  onChange={(e) => updateField("segment", e.target.value)}
                  className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm appearance-none bg-white dark:bg-gray-900 pr-8 focus:outline-none focus:ring-1 focus:ring-indigo-300"
                >
                  <option>New Customers</option>
                  <option>Returning Customers</option>
                  <option>VIP Customers</option>
                </select>
                <div className="absolute right-2 top-3 pointer-events-none">
                  <svg viewBox="0 0 24 24" className="w-4 h-4 fill-none stroke-gray-500 stroke-2"><polyline points="6 9 12 15 18 9" /></svg>
                </div>
              </div>
            </>
          )}

          <RightDot />
        </div>
      </div>

      {showDeleteModal && (
        <DeleteModal
          title="Delete trigger?"
          description="This will remove the trigger and any connected flow from your bot journey. This action cannot be undone."
          confirmLabel="Delete Trigger"
          onConfirm={() => { onDelete(); setShowDeleteModal(false); }}
          onCancel={() => setShowDeleteModal(false)}
        />
      )}
    </>
  );
};